// removed by extract-text-webpack-plugin
module.exports = {"overlay":"style__overlay___2cauS","overlayModal":"style__overlayModal___1huxN","overlayModalInner":"style__overlayModalInner___fYag9","overlayCloseButton":"style__overlayCloseButton___3siZU","overlayModalTitle":"style__overlayModalTitle___qA7as","overlayModalText":"style__overlayModalText___20FS5","overlayModalTextBold":"style__overlayModalTextBold___3vDxI","overlayModalButtons":"style__overlayModalButtons___mifRv","overlayModalButtonsItem":"style__overlayModalButtonsItem___O9fSb","overlayModalButtonsItemButton":"style__overlayModalButtonsItemButton___30Zt1","buttonActive":"style__buttonActive___1ICZ7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/modal-maxrelated/style.css
// module id = 1134
// module chunks = 0